import * as tslib_1 from "tslib";
import { IgrCellInfo } from "./igr-cell-info";
import { RowSeparatorModel as RowSeparatorModel_internal } from "./RowSeparatorModel";
/**
 * Represents backing information for the row separators.
*/
var IgrRowSeparatorInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrRowSeparatorInfo, _super);
    function IgrRowSeparatorInfo() {
        return _super.call(this) || this;
    }
    IgrRowSeparatorInfo.prototype.createImplementation = function () {
        return new RowSeparatorModel_internal();
    };
    Object.defineProperty(IgrRowSeparatorInfo.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    return IgrRowSeparatorInfo;
}(IgrCellInfo));
export { IgrRowSeparatorInfo };
//# sourceMappingURL=igr-row-separator-info.js.map
